
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/business-collection",
      function () {
        return require("private-next-pages/services/business-collection/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/business-collection"])
      });
    }
  